import Autocomplete from "@tomickigrzegorz/autocomplete";
import geocoder from "../geocoder";
import { defaults } from "../autocomplete";

const MAXIMUM_LOCATIONS = 10;

export default (locations = []) => ({
  locations: locations,

  init() {
    const geocode = geocoder(false);

    this.autocomplete = new Autocomplete(this.$refs.input.id, {
      ...defaults,
      onSearch: async ({ currentValue }) => {
        this.abortController?.abort();
        this.abortController = new AbortController();

        try {
          const locations = await geocode(
            currentValue,
            {
              includeAddresses: false,
              includeStates: true,
            },
            this.abortController.signal,
          );

          this.abortController = null;
          return locations;
        } catch (error) {
          this.abortController = null;

          if (error.name === "AbortError") {
            return [];
          }

          console.error(error);
          return [];
        }
      },

      onSubmit: async ({ object }) => {
        const locationIds = new Set(
          this.locations.map((location) => location.id),
        );

        if (!locationIds.has(object.id)) {
          this.locations.push(object);

          this.$refs.input.value = "";
        }
      },
    });
  },

  get multipleRegions() {
    return new Set(this.locations.map((location) => location.region)).size > 1;
  },

  get maximumLocations() {
    return this.locations.length >= MAXIMUM_LOCATIONS;
  },

  locationLabel(location) {
    return [location.neighborhood, location.place, location.region]
      .filter((x) => x)
      .join(", ");
  },
});
